import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import {
  GetWalletConnectionResponseType,
  PostWalletConnectionRequestType,
  PostWalletConnectionResponseType
} from '@/entities';

export const getWalletConnection = async (
  account: string,
  tgInitData?: string
): Promise<GetResponseType<GetWalletConnectionResponseType>> => {
  const { data, error, loading, httpCode } = await ApiClient.get<GetWalletConnectionResponseType>(
    `${window.config.api_endpoint}/users/me/wallet-connection?account=${account}`,
    tgInitData || WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const postWalletConnection = async (
  proof: PostWalletConnectionRequestType,
  tgInitData?: string
): Promise<GetResponseType<PostWalletConnectionResponseType>> => {
  const { data, error, loading, httpCode } = await ApiClient.post<PostWalletConnectionResponseType>(
    `${window.config.api_endpoint}/users/me/wallet-connection?account=${proof.account}`,
    proof,
    tgInitData || WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const postWalletDisconnection = async (
  tgInitData?: string
): Promise<GetResponseType<void>> => {
  const { data, error, loading, httpCode } = await ApiClient.post<void>(
    `${window.config.api_endpoint}/users/me/wallet-disconnection`,
    {},
    tgInitData || WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const postWalletDownloaded = async (tgInitData?: string): Promise<GetResponseType<void>> => {
  const { data, error, loading, httpCode } = await ApiClient.post<void>(
    `${window.config.api_endpoint}/users/me/wallet-downloaded`,
    {},
    tgInitData || WITH_AUTH
  );
  return {
    data,
    httpCode,
    error,
    loading
  };
};
